"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with template objects
 */
class TemplatesPreviewApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/templates';
    }
    /**
     * Get all template objects grouped by types.
     *
     * @returns Returns an object GroupedTemplatesObject, which contains an array of template objects TemplateEntity
     */
    async getAllTemplates() {
        const result = await this._fetchGet('/all');
        return result;
    }
    /**
     * Get template objects by type.
     *
     * @param {Types} [type] - Product marker
     *
     * @returns Returns a TemplateEntity object
     */
    async getTemplateByType(type) {
        const result = await this._fetchGet(`?type=${type}`);
        return result;
    }
}
exports.default = TemplatesPreviewApi;
